import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FamilyApi } from '@core/apis/family/family.api';
import { FamilyDTO } from '@core/apis/family/family.dto';
import { PatientDTO } from '@core/apis/patient/patient.dto';
import { FamilyDeleteConfirmationModalComponent } from '@core/components/family-delete-confirmation-modal/family-delete-confirmation-modal.component';
import { InfoProcessingModalComponent } from '@core/components/info-processing-modal/info-processing-modal.component';
import { FullNamePipe } from '@core/pipes/full-name.pipe';
import { SignedUrlPipe } from '@core/pipes/signed-url.pipe';
import { UserStore } from '@core/stores/user.store';
import { TranslocoModule } from '@jsverse/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@Component({
  selector: 'app-family',
  imports: [
    RouterModule,
    TranslocoModule,
    CommonModule,
    SignedUrlPipe,
    FormsModule,
    FullNamePipe,
    FamilyDeleteConfirmationModalComponent,
    InfoProcessingModalComponent,
  ],
  templateUrl: './family.component.html',
  styleUrl: './family.component.scss',
})
@UntilDestroy()
export class FamilyComponent {
  public patient: PatientDTO | null = null;
  public familyMembers: FamilyDTO[] = [];
  public openedDetailIndex: number | null = null;
  public patientId: number | null = null;
  public userId: number | undefined = undefined;
  public awsPath(id: number): string {
    return 'patients/' + id + '/avatar';
  }
  @ViewChild(FamilyDeleteConfirmationModalComponent)
  familyDeleteConfirmationDialog!: FamilyDeleteConfirmationModalComponent;

  @ViewChild(InfoProcessingModalComponent)
  modal!: InfoProcessingModalComponent;

  constructor(
    private readonly userStore: UserStore,
    private readonly familyApi: FamilyApi,
  ) {
    this.userId = this.userStore.get()?.id;
    this.get();
  }

  public get() {
    if (!this.userId) return;
    this.familyApi
      .get(this.userId)
      .pipe(untilDestroyed(this))
      .subscribe((data) => {
        this.familyMembers = data;
      });
  }
  public toggleDetails(index: number): void {
    this.openedDetailIndex = this.openedDetailIndex === index ? null : index;
  }

  public openModal(id: number): void {
    this.patientId = id;
    this.familyDeleteConfirmationDialog.openModalq();
  }
  public delete(): void {
    if (!this.patientId) return;
    this.familyApi
      .delete(this.patientId)
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.get();
      });
  }
  public openModalInfo() {
    this.modal.openModal();
  }
}
